import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import { Button, SelectBox as SelectBoxUntyped, MultiSelect as MultiSelectUntyped, TextArea as TextAreaUntyped } from '../../primary';
import { CANCEL_ID, CANCEL_BTN, SUBMIT_ID, SAVE_BTN } from '../../../constants';
import styles from './assign.module.scss';
import { Modal } from '../../secondary';
import { occurrences } from '../../../utils';
import type { FormBuilderQuestion, FormRule } from '../../../features/custom-forms';

const SelectBox = SelectBoxUntyped as unknown as React.ComponentType<{
    id?: string;
    name?: string;
    label?: React.ReactNode;
    classes?: Record<string, string>;
    optionValue: Array<{ key: string; value: string }>;
    placeholder?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}>;

interface RuleOption {
    key: string | number;
    value: string;
}

/** `FormBuilderQuestion.productAttributeFilter` is `unknown` in the shared type (set by
 * `ProductAttributeDivision`, not yet typed) -- narrow it locally to the one field this
 * file reads. */
interface ProductAttributeFilter {
    productAttributeLabel?: string;
}

const MultiSelect = MultiSelectUntyped as unknown as React.ComponentType<{
    id?: string;
    name?: string;
    label?: React.ReactNode;
    classes?: Record<string, string>;
    optionValue: RuleOption[];
    showCheckbox?: boolean;
    displayValue?: string;
    onSelect?: (selectedList: RuleOption[], selectedItem: RuleOption) => void;
    onRemove?: (removeList: RuleOption[], removeItem: RuleOption) => void;
    defaultValue?: Array<string | number> | string;
}>;

const TextArea = TextAreaUntyped as unknown as React.ComponentType<{
    id?: string;
    name?: string;
    classes?: Record<string, string>;
    placeholder?: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    value?: string;
    errors?: unknown;
}>;

interface AddRuleTextProps {
    modalOpen: boolean;
    modalClose: () => void;
    addRuleList: FormBuilderQuestion[];
    getRuleData: (rule: FormRule) => void;
    defaultValue?: FormRule | null;
}

export const AddRuleText: React.FC<AddRuleTextProps> = ({ modalOpen, modalClose, addRuleList, getRuleData, defaultValue }) => {
    const { reset } = useForm();
    const [ruleType, setRuleType] = useState<string>('')
    const [attributes, setAttributes] = useState<RuleOption[]>([])
    const [questions, setQuestions] = useState<RuleOption[]>([])
    const [showlistAttr, setShowListAttr] = useState<RuleOption[]>([])
    const [showlistFamily, setShowListFamily] = useState<RuleOption[]>([])
    const [showlistMaterial, setShowListMaterial] = useState<RuleOption[]>([])
    const [showlist, setShowList] = useState<RuleOption[]>([])
    const [textArea, setTextArea] = useState<string>('')
    const [expression, setExpression] = useState<Array<string | number>>([])
    const [defaultData, setDefaultData] = useState<boolean>(true)
    const [materials, setMaterials] = useState<RuleOption[]>([])
    const [customMsgErr, setCustomMsgErr] = useState<string | { textArea: { message: string } }>('')

    useEffect(() => {
        const endOfFormRuleEl = document.getElementById('endofformrule') as HTMLSelectElement | null;
        if (endOfFormRuleEl) {
            endOfFormRuleEl.value = defaultValue?.ruleOption ?? '';
        }
        setCustomMsgErr('')
    }, [defaultValue, modalOpen])

    useEffect(() => {
        if (defaultValue?.expression !== null) {
            setExpression(defaultValue?.expression ?? [])
        }
    }, [defaultValue, modalOpen])

    useEffect(() => {
        if (defaultValue !== null && defaultValue !== undefined) {
            setRuleType(defaultValue?.ruleOption)
            setTextArea(defaultValue?.textArea)
            changeEndofRule(defaultValue?.ruleOption, 1)

            let arrAttr: RuleOption[] = []
            let arrFam: RuleOption[] = []
            let arrMat: RuleOption[] = []
            defaultValue?.attribute?.length > 0 && Array.isArray(defaultValue.attribute)&& defaultValue?.attribute?.forEach((val) => {//NOSONAR
               Array.isArray(addRuleList)&&addRuleList?.map(//NOSONAR
                    (item) => {//NOSONAR
                        if (item.optionType === "productattribute") {
                            if (val === item.id) {
                                let obj = { key: item?.id, value: (item?.productAttributeFilter as ProductAttributeFilter | undefined)?.productAttributeLabel ?? '' }
                                arrAttr = [...arrAttr, obj]
                                return setShowListAttr(arrAttr)//NOSONAR
                            }
                        }
                    }//NOSONAR
                )//NOSONAR
            })//NOSONAR

            defaultValue?.productQuestion?.length > 0 && Array.isArray(defaultValue.productQuestion)&& defaultValue?.productQuestion?.forEach((val) => {//NOSONAR
                Array.isArray(addRuleList)&&addRuleList?.map(//NOSONAR
                    (item, index) => {//NOSONAR
                        if (item.optionType === "productfamily") {
                            if (val === item.id) {
                                let obj = { key: item?.id, value: `${index + 1}.${item?.desc}` }
                                arrFam = [...arrFam, obj]
                                return setShowListFamily(arrFam)//NOSONAR
                            }
                        }
                    }//NOSONAR
                )//NOSONAR
            })//NOSONAR

            defaultValue?.productMaterial?.length > 0 && Array.isArray(defaultValue.productMaterial)&& defaultValue?.productMaterial?.forEach((val) => {//NOSONAR
                Array.isArray(addRuleList)&&addRuleList?.map(//NOSONAR
                    (item, index) => {//NOSONAR
                        if (item.optionType === "productmaterial") {
                            if (val === item.id) {
                                let obj = { key: item?.id, value: `${index + 1}.${item?.desc}` }
                                arrMat = [...arrMat, obj]
                                return setShowListMaterial(arrMat)//NOSONAR
                            }
                        }
                    }//NOSONAR
                )//NOSONAR
            })//NOSONAR
        } else {
            setRuleType('Select');
        }
    }, [addRuleList, defaultValue, modalOpen])
    const modalRefresh = () => {
        reset();
        setRuleType('Select')
        setShowListAttr([])
        setShowListFamily([])
        setShowListMaterial([])
        setShowList([])
        modalClose();
    }
    const changeEndofRule = (value: string, def = 0) => {
        if (value !== "custommessage") {
            let arrAttr: RuleOption[] = []
            let arrFam: RuleOption[] = []
            let arrMat: RuleOption[] = []
            Array.isArray(addRuleList)&&addRuleList?.map(
                (item, index) => {//NOSONAR
                    if (item.optionType === "productattribute") {
                        let obj = { key: item?.id, value: `${index + 1}.${(item?.productAttributeFilter as ProductAttributeFilter | undefined)?.productAttributeLabel}` }
                        arrAttr = [...arrAttr, obj]
                       return setAttributes(arrAttr)//NOSONAR
                    }
                    if (item.optionType === "productfamily") {
                        let obj = { key: item?.id, value: `${index + 1}.${item?.desc}` }
                        arrFam = [...arrFam, obj]
                        return setQuestions(arrFam)//NOSONAR
                    }
                    if (item.optionType === "productmaterial") {
                        let obj = { key: item?.id, value: `${index + 1}.${item?.desc}` }
                        arrMat = [...arrMat, obj]
                        return setMaterials(arrMat)//NOSONAR
                    }
                })//NOSONAR
            let optAttr = addRuleList?.find(o => o.optionType === 'productattribute')
            let optQues = addRuleList?.find(o => o.optionType === 'productfamily')
            let optMat = addRuleList?.find(o => o.optionType === 'productmaterial')
            if(optAttr === undefined){setAttributes([])}
            if(optQues === undefined){setQuestions([])}
            if(optMat === undefined){setMaterials([])}
        }
        setDefaultData(true)
        setRuleType(value)
        if (def === 0) {
            setDefaultData(false)
            setTextArea('')
            setExpression([])
            setShowListAttr([])
            setShowListFamily([])
            setShowListMaterial([])
        }
    }
    const handleCancel = (e: React.MouseEvent) => {
        setRuleType('Select')
        setShowListAttr([])
        setShowListFamily([])
        setShowListMaterial([])
        setShowList([])
        setExpression([])
        setErrorMsg(false)
        reset();
        e.preventDefault();
        modalClose();
    }
    const getRuleValue = (selectedList: RuleOption[], selectedItem: RuleOption, type: string) => {
        if (expression?.length > 0) {
            const showListData = [...expression, " AND ", "", selectedItem.key, ""]
            setExpression(showListData)
        } else {
            const showListData = ["", selectedItem.key, ""]
            setExpression(showListData)
        }
        if (type === "attributes") {
            setShowListAttr(selectedList)
        } else if(type==="family") {
            setShowListFamily(selectedList)
        }else{
            setShowListMaterial(selectedList)
        }
    }
    const removeRuleValue = (removeList: RuleOption[], removeItem: RuleOption, type: string) => {
        const getInd = expression?.findIndex((x) => x == removeItem.key)
        const showListData = [...expression]
        showListData.splice(getInd, 3)
        showListData.splice(getInd - 1, 1)
        const len = showListData?.length - 1;
        if(showListData[len] == ' AND ' || showListData[len] == ' OR ') {
            showListData.splice(len, len)
        }
        setExpression(showListData)
        if (type === "attributes") {
            setShowListAttr(removeList)
        } else if(type==="family") {
            setShowListFamily(removeList)
        }else{
            setShowListMaterial(removeList)
        }
    }
    const getAnswer = (val: string) => {
        setTextArea(val)
    }
    // State to display error message
    const [errorMsg, setErrorMsg] = useState<string | false>(false)

    useEffect(() => {
        if (errorMsg !== false) {
            setTimeout(() => {
                setErrorMsg(false)
            }, 5000)
        }
    }, [errorMsg])
    const saveRule = () => {
        let container = document.getElementById(`ruleData`);

        // Payload text and expression data
        let payloadElements = document.querySelectorAll(`.editTable`);
        let payloadExp: string[] = [];
        let payloadTxt = '';

        payloadElements.forEach((element) => {
            payloadTxt += element.textContent ?? ''
            payloadExp = [...payloadExp, element.textContent ?? '']
        });

        if (container) {
            let elements = container.querySelectorAll('span:not(.ruleHide)')
            let exp: string[] = [];
            let txt = '';
            let codes: string[] = [];
            let operators: string[] = [];
            elements.forEach((element) => {
                // Removing parantheses if there is any 
                let stripedText = element?.textContent?.replace(/[{()}]/g, '') ?? '';
                //console.log('stripedText', stripedText)
                txt += element.textContent
                exp = [...exp, stripedText]
                // Adding only attributes and family, not the AND and OR
                if (stripedText !== '' && stripedText !== String.fromCharCode(160) && stripedText.trim() !== 'AND' && stripedText.trim() !== 'OR') {
                    codes = [...codes, stripedText]
                }
                if(stripedText.trim() === 'AND' || stripedText.trim() === 'OR'){
                    operators = [...operators, stripedText.trim()]
                }
            });

            //console.log(operators, codes); 
            // This is for coming out of save action
            let breaker = false;

            // Extra ANDs and ORs

            if(operators.length !== codes.length - 1){
                //console.log('operator');
                setErrorMsg('Oops invalid expression , the allowed expression or only AND, OR , “(“ and “)” please remove other expression and also validate if all the open braces are closed.')
                breaker = true;
            }

            if(breaker !== false){
                return;
            }

            let lCount = occurrences(txt, '(', true)
            let rCount = occurrences(txt, ')', true)
            if (lCount !== rCount) {
                //console.log('(((');
                setErrorMsg('Oops invalid expression , the allowed expression or only AND, OR , “(“ and “)” please remove other expression and also validate if all the open braces are closed.')
                breaker = true;
            }

            if (breaker !== false) {
                return;
            }

            // Checking wheather the entered data is right or wrong
            codes?.forEach((item) => {//NOSONAR
                const findQuestion = questions?.find(x => x.value === item);
                const findAttribute = attributes?.find(x => x.value === item);
                const findMaterials = materials?.find(x => x.value === item);
                if (findAttribute === undefined && findQuestion === undefined&&findMaterials===undefined) {
                    //console.log('attr');
                    setErrorMsg('Oops invalid expression , the allowed expression or only AND, OR , “(“ and “)” please remove other expression and also validate if all the open braces are closed.')
                    breaker = true;
                    return;
                }
            })//NOSONAR

            if (breaker !== false) {
                return;
            }
        }
        if(ruleType === "custommessage"&&textArea==''){
            setCustomMsgErr({textArea:{message:'Please enter custom message'}})
            return;
        }else{
            setCustomMsgErr('');
        }

        let attr: Array<string | number> = []
        Array.isArray(showlistAttr)&&showlistAttr?.map((item) => {//NOSONAR
            attr = [...attr, item.key]
        })//NOSONAR

        let family: Array<string | number> = []
        Array.isArray(showlistFamily)&&showlistFamily?.map((item) => {//NOSONAR
            family = [...family, item.key]
        })//NOSONAR

        let material: Array<string | number> = []
        Array.isArray(showlistMaterial)&&showlistMaterial?.map((item) => {//NOSONAR
            material = [...material, item.key]
        })//NOSONAR

        const rule: FormRule = {
            ruleOption: ruleType,
            attribute: attr,
            productQuestion: family,
            productMaterial: material,
            textArea: ruleType === "custommessage" ? textArea : payloadTxt,
            expression: payloadExp
        }
        getRuleData(rule)
        modalClose();
    }
    return (
        <Modal
            modalOpen={modalOpen}
            modalClose={modalRefresh}
            heading={"Add Rule"}
            className={"modal_box"}
            modalSize={styles.custom_modal_size}
        >
            <div className={`pl-2 ${styles.patient_content}`}>
                <SelectBox
                    id={`endofformrule`}
                    name={`endofformrule`}
                    label={`End of Form Rule:`}
                    classes={{
                        column: `col-12 ${styles.col_spec}`,
                        inputClassName: `${styles.type_rule_select}`,
                        labelClassName: `col-4 col-form-label ${styles.label_spec}`,
                        inputColumn: `col-6 p-0 ${styles.select_wrapper}`
                    }}
                    optionValue={[
                        { key: 'custommessage', value: 'Display Custom Message' },
                        //{ key: 'Display Products (product attributes)', value: 'Display Products (product attributes)' },
                        //{ key: 'Display Products (product family)', value: 'Display Products (product family)' },
                       // { key: 'Display Products (product attribute, product family)', value: 'Display Products (product attribute, product family)' }
                       { key: 'Display Products (product attribute, product family, material #)', value: 'Display Products (product attribute, product family,material #)' }
                    ]}
                    placeholder={"Select"}
                    onChange={(e) => changeEndofRule(e.target.value)}
                />
                {attributes&&Array.isArray(attributes)&&attributes.length>0&&ruleType === "Display Products (product attribute, product family, material #)" ? <MultiSelect
                    id={"selectAttribute"}
                    name={"selectAttribute"}
                    label={"Select Attribute(s):"}
                    classes={{
                        column: `col-12 ${styles.col_spec}`,
                        inputClassName: styles.basic_select,
                        labelClassName: `col-4 col-form-label ${styles.label_spec}`,
                        inputColumn: `col-6 p-0 ${styles.select_wrapper}`
                    }}
                    optionValue={attributes}
                    showCheckbox={true}
                    displayValue="value"
                    onSelect={(selectedList, selectedItem) => getRuleValue(selectedList, selectedItem, 'attributes')}
                    onRemove={(removeList, removeItem) => removeRuleValue(removeList, removeItem, 'attributes')}
                    defaultValue={defaultData ? defaultValue?.attribute : ''}
                /> : ''}
                {questions&&Array.isArray(questions)&&questions.length>0&&ruleType === "Display Products (product attribute, product family, material #)"  ? <MultiSelect
                    id={"selectQuestion"}
                    name={"selectQuestion"}
                    label={"Select Product Family(s):"}
                    classes={{
                        column: `col-12 ${styles.col_spec}`,
                        inputClassName: styles.basic_select,
                        labelClassName: `col-4 col-form-label ${styles.label_spec}`,
                        inputColumn: `col-6 p-0 ${styles.select_wrapper}`
                    }}
                    optionValue={questions}
                    showCheckbox={true}
                    displayValue="value"
                    onSelect={(selectedList, selectedItem) => getRuleValue(selectedList, selectedItem, 'family')}
                    onRemove={(removeList, removeItem) => removeRuleValue(removeList, removeItem, 'family')}
                    defaultValue={defaultData ? defaultValue?.productQuestion : ''}
                /> : ''}

{materials&&Array.isArray(materials)&&materials.length>0&&ruleType === "Display Products (product attribute, product family, material #)"  ? <MultiSelect
                    id={"selectMaterial"}
                    name={"selectMaterial"}
                    label={"Select Material #(s):"}
                    classes={{
                        column: `col-12 ${styles.col_spec}`,
                        inputClassName: styles.basic_select,
                        labelClassName: `col-4 col-form-label ${styles.label_spec}`,
                        inputColumn: `col-6 p-0 ${styles.select_wrapper}`
                    }}
                    optionValue={materials}
                    showCheckbox={true}
                    displayValue="value"
                    onSelect={(selectedList, selectedItem) => getRuleValue(selectedList, selectedItem, 'productMaterial')}
                    onRemove={(removeList, removeItem) => removeRuleValue(removeList, removeItem, 'productMaterial')}
                    defaultValue={defaultData ? defaultValue?.productMaterial : ''}
                /> : ''}
                <div className={`col-12 ${styles.col_spec}`}>
                    <label className={`col-4 col-form-label ${styles.label_spec}`} ></label>
                    {ruleType == "custommessage" ?
                        <TextArea
                            id={`textArea`}
                            name={`textArea`}
                            classes={{
                                column: `col-7 col-form-label ${styles.col_spec}`,
                                inputClassName: `${styles.text_content} getAns`,
                                labelClassName: `col-1 col-form-label ${styles.label_spec}`,
                                inputColumn: `col-12 p-0`
                            }}
                            placeholder={"Enter a response"}
                            onChange={(e) => getAnswer(e.target.value)}
                            value={textArea}
                            errors={customMsgErr}
                        />
                        :
                        <div className={`col-6 p-0 ${styles.edit_textarea}`} id="ruleData">
                            {

                                expression?.map((item, ind) => {
                                    if (isNaN(Number(item)) || item === "") {
                                        // Deliberately the raw lowercase `contenteditable` attribute (not the React
                                        // `contentEditable` prop): React passes unrecognized attributes through to the
                                        // DOM as-is, which is what the legacy JS relied on. Using the recognized
                                        // `contentEditable` prop here instead would trigger React's "contentEditable
                                        // with managed children" dev warning on every render -- a new side effect the
                                        // legacy code never had. Preserved verbatim via a spread to satisfy JSX typing.
                                        return <span key={ind} {...{ contenteditable: "true" }} className="editTable">{item}</span>
                                    } else {
                                        const findQuestion = questions?.find(x => x.key == item);
                                        const findAttribute = attributes?.find(x => x.key == item);
                                        const findMaterials = materials?.find(x => x.key == item);
                                        return <React.Fragment key={ind}>
                                            <span className={`editTable ${styles.display_none} ruleHide`}>{item}</span>
                                            {findAttribute !== undefined ? <span>{findAttribute?.value}</span> : ''}
                                            {findQuestion !== undefined ? <span>{findQuestion?.value}</span> : ''}
                                            {findMaterials !== undefined ? <span>{findMaterials?.value}</span> : ''}
                                        </React.Fragment>
                                    }
                                })
                            }
                        </div>
                    }
                </div>
                {errorMsg && <div className="col-sm-6 text-danger offset-4 p-0 pb-3">
                    {errorMsg}
                </div>}
                <div className="col-sm-12">
                    <div className="text-center pb-4">
                        <Button
                            classes={{ className: `btn ${styles.btn_custom} ${styles.btn_small}` }}
                            type="button"
                            id={SUBMIT_ID}
                            onClick={() => saveRule()}
                        >
                            {SAVE_BTN}
                        </Button>
                        <Button
                            classes={{ className: `btn ${styles.btn_custom} ${styles.btn_small_cancel}` }}
                            id={CANCEL_ID}
                            onClick={handleCancel}
                        >
                            {CANCEL_BTN}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
